export var pillIconBehavior = function pillIconBehavior() {
  return {
    attributes: {
      root: {
        'aria-hidden': true
      }
    }
  };
};
//# sourceMappingURL=pillIconBehavior.js.map
